<!--
 * @Author: zl
 * @Date: 2022-04-24 10:43:35
 * @LastEditTime: 2022-12-16 10:56:15
 * @LastEditors: zl
 * @Description: 审计统计
-->
<template>
	<div class="AuditReport-layout filter-layout">
		<div class="filter-box mb10">
			<h3 class="text-center pdt10 mb20">
				东部新中心建设项目审计作业统计报表
				<el-tooltip placement="bottom-start"
							effect="light">
					<template slot="content">
						<p><span>数据统计说明：默认展示当前月份数据统计。</span></p>
						<p><span><br></span></p>
						<p><span>当选择起止月份后，则统计起止月份内的表单数。</span></p>
					</template>
					<svg-icon icon-class="wenhao"
							  style="color: #888"></svg-icon>
				</el-tooltip>
			</h3>
			<!-- 搜索内容区域 -->
			<el-form ref="searchForm"
					 :model="searchForm"
					 size="small"
					 label-width="100px">
				<el-row :gutter="10"
						type="flex"
						justify="space-between">
					<el-col :span="9">
						<el-form-item label-width="10">
							筛选时间统计: {{ filterTime }}
						</el-form-item>
					</el-col>
					<el-col :span="15"
							class="custom-item">
						<el-form-item label="选择时间"
									  prop="month"
									  style="width:375px">
							<el-date-picker v-model="searchForm.month"
											type="monthrange"
											:clearable="false"
											format="yyyy年MM月"
											value-format="yyyy-MM"
											range-separator="-"
											start-placeholder="开始时间"
											end-placeholder="结束时间"
											placeholder="请选择月份"
											@change="monthChange"></el-date-picker>
						</el-form-item>
						<el-form-item label-width="0"
									  class="ml10">
							<el-button type="primary"
									   size="small"
									   icon="el-icon-menu"
									   @click="doFilter('top', '1098009')">列过滤</el-button>
							<el-button size="small"
									   @click="exportExcelMethod('total')">导出Excel</el-button>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<!-- 合计表格 -->
			<vxe-table align="center"
					   auto-resize
					   resizable
					   border
					   :data="tableObj.totalData"
					   highlight-current-row
					   highlight-hover-row
					   height="217px"
					   ref="topTable"
					   @cell-click="cellClick"
					   :cell-class-name="cellStyle"
					   :loading="tableObj.totalLoading"
					   show-header-overflow="tooltip"
					   show-overflow="tooltip">
				<vxe-column title="片区"
							field="name"
							width="100"></vxe-column>
				<vxe-column title="合计"
							field="moduleType"
							width="100">
					<template #default="{ row }">
						<span class="vxe-cell--label custom-cell">
							<strong>{{ row.moduleType }}</strong>
						</span>
					</template>
				</vxe-column>
				<vxe-column v-for="item in moduleList"
							:key="item.field"
							:title="item.sname"
							:field="item.field"
							min-width="150">
					<template #default="{ row }">
						<span class="vxe-cell--label custom-cell">
							<strong>{{ row[item.field] }}</strong>
						</span>
					</template>
				</vxe-column>
			</vxe-table>
		</div>
		<div class="filter-content primary-layout">
			<!-- 内容区域 提示信息 和 导出excel、列过滤 -->
			<div class="primary-header">
				<div class="left-text">
					<span class="tips">
						<i class="el-icon-warning"></i>
						<span v-html="this.customTip()"></span>
					</span>
				</div>
				<div class="btnGroups">
					<el-input v-model="searchForm.projectName"
							  size="small"
							  placeholder="请输入项目名称"
							  clearable
							  class="custom-input-inner">
						<el-button class="btn-success"
								   size="small"
								   slot="append"
								   @click="submitForm">查询</el-button>
					</el-input>

					<!-- 弹出框搜素区域 -->
					<el-popover placement="bottom-end"
								width="415"
								trigger="click">
						<el-form ref="searchForm"
								 :model="searchForm"
								 size="small"
								 label-width="100px">
							<el-form-item label="项目类型"
										  prop="newProType">
								<el-select v-model="searchForm.newProType"
										   placeholder="请选择"
										   clearable>
									<el-option v-for="item in projectDict.dxxmlx"
											   :key="item.id"
											   :label="item.sname"
											   :value="item.value"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="建设单位"
										  prop="constructionUnit">
								<el-select v-model="searchForm.constructionUnit"
										   placeholder="请选择"
										   clearable>
									<el-option v-for="(item, index) in constructionUnitList"
											   :key="index"
											   :label="item.sname"
											   :value="item.ownerUnit"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="计划编排类别"
										  prop="start">
								<el-select v-model="searchForm.start"
										   placeholder="请选择">
									<el-option v-for="item in typeOptions"
											   :key="item.value"
											   :label="item.label"
											   :value="item.value"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="建设类型"
										  prop="constructionType">
								<el-select v-model="searchForm.constructionType"
										   placeholder="请选择"
										   clearable>
									<el-option v-for="item in projectDict.dxjslx"
											   :key="item.id"
											   :label="item.sname"
											   :value="item.value"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label-width="0"
										  class="text-center borderTop">
								<el-button type="primary"
										   icon="el-icon-search"
										   @click="submitForm">查询</el-button>
								<el-button icon="el-icon-refresh"
										   @click="resetForm">重置</el-button>
							</el-form-item>
						</el-form>
						<el-button type="success"
								   size="small"
								   slot="reference"
								   icon="el-icon-arrow-down"
								   class="ml10 mr10 btn-success"></el-button>
					</el-popover>
					<el-button type="primary"
							   size="small"
							   icon="el-icon-menu"
							   @click="doFilter('bottom', '1098010')">列过滤</el-button>
					<el-button size="small"
							   @click="exportExcelMethod('list')">导出Excel</el-button>
				</div>
			</div>
			<!-- 内容表格 -->
			<div class="primary-content mt10">
				<div class="w-table-layout">
					<vxe-table align="center"
							   auto-resize
							   resizable
							   border
							   ref="patrolsTable"
							   :data="tableObj.data"
							   height="95%"
							   highlight-current-row
							   highlight-hover-row
							   :loading="tableObj.loading"
							   show-header-overflow="tooltip"
							   show-overflow="tooltip">
						<vxe-column title="序号"
									type="seq"
									width="65"></vxe-column>
						<vxe-column title="项目名称"
									field="proName"
									header-align="center"
									align="left"
									min-width="150">
							<template #default="{ row }">
								<span class="vxe-cell--label blue-text"
									  @click="doClick(row, 'enter')">
									{{ row.proName }}
								</span>
							</template>
						</vxe-column>
						<vxe-column title="标段名称"
									field="packName"
									header-align="center"
									align="left"
									min-width="150"
									:visible="false"></vxe-column>
						<vxe-column title="片区"
									field="isNorthName"
									width="100"></vxe-column>
						<vxe-column title="建设单位"
									field="constructionShortName"
									min-width="150"
									header-align="center"
									align="left">
							<template #default="{ row }">
								<el-tooltip effect="dark"
											:content="row.constructionUnitName"
											placement="top">
									<span class="vxe-cell--label">{{ row.constructionShortName }}</span>
								</el-tooltip>
							</template>
						</vxe-column>
						<vxe-column title="计划编排类别"
									field="striveStart"
									width="120"></vxe-column>
						<vxe-column title="项目类型"
									field="newProTypeName"
									width="120px"
									:visible="false"></vxe-column>
						<vxe-column title="建设类型"
									field="constructionTypeName"
									width="120px"
									:visible="false"></vxe-column>
						<vxe-column title="争取开工年份"
									field="striveStartDate"
									width="120px"
									:visible="false"></vxe-column>
						<vxe-column title="表单名称"
									field="sname"
									min-width="150px"
									header-align="center"
									align="left"></vxe-column>
						<vxe-column title="表单类型"
									field="moduleTypeName"
									min-width="150px"></vxe-column>
						<vxe-column title="协审单位"
									field="assistantShortName"
									min-width="150"
									header-align="center"
									align="left">
							<template #default="{ row }">
								<el-tooltip effect="dark"
											:content="row.assistantTenantName"
											placement="top">
									<span class="vxe-cell--label">{{ row.assistantShortName }}</span>
								</el-tooltip>
							</template>
						</vxe-column>
						<vxe-column title="操作人"
									field="submitUserName"
									width="120px"></vxe-column>
						<vxe-column title="操作单位"
									field="submitShortName"
									width="130px"
									header-align="center"
									align="left"
									:visible="false">
							<template #default="{ row }">
								<el-tooltip effect="dark"
											:content="row.submitTenantName"
											placement="top">
									<span class="vxe-cell--label">
										{{ row.submitShortName }}
									</span>
								</el-tooltip>
							</template>
						</vxe-column>
						<vxe-column title="操作日期"
									field="submitTime"
									width="120px">
							<template #default="{ row }">
								<el-tooltip effect="dark"
											:content="row.submitTime"
											:disabled="!row.submitTime"
											placement="top">
									<span class="vxe-cell--label"
										  v-if="!!row.submitTime">
										{{ row.submitTime.substr(0, 11) }}
									</span>
									<span v-else>-</span>
								</el-tooltip>
							</template>
						</vxe-column>
						<vxe-column title="操作"
									width="180">
							<template #default="{ row }">
								<el-button type="primary"
										   round
										   plain
										   class="table-btn"
										   v-if="roleBtns.includes('view')"
										   @click="doClick(row, 'view')">
									<svg-icon icon-class="form-look"></svg-icon> 查看
								</el-button>
								<el-button type="primary"
										   round
										   plain
										   class="table-btn"
										   v-if="roleBtns.includes('enter')"
										   @click="doClick(row, 'enter')">
									<svg-icon icon-class="form-enter"></svg-icon> 进入项目
								</el-button>
							</template>
						</vxe-column>
					</vxe-table>
				</div>
			</div>
		</div>

		<!-- 列过滤 -->
		<ColumnFilter ref="ColumnFilter"
					  v-if="showFilter"
					  :filterColumns="filterColumns"
					  :busType="busType"
					  memory
					  @onFilter="onFilter"></ColumnFilter>

		<!-- 查看 -->
		<el-dialog :title="dialog.title"
				   :visible.sync="dialog.show"
				   width="1000px"
				   top="4vh"
				   center
				   custom-class="custom-height-audit"
				   :close-on-click-modal="false"
				   :destroy-on-close="false"
				   :before-close="dialogClose"
				   v-if="dialog.show">
			<template v-if="currentObj.moduleType == '1'">
				<AuditPlan :currentObj="currentObj"></AuditPlan>
			</template>
			<template v-if="currentObj.moduleType == '2'">
				<AuditLog :currentObj="currentObj"></AuditLog>
			</template>
			<template v-if="currentObj.moduleType == '3'">
				<AuditSupervision :currentObj="currentObj"></AuditSupervision>
			</template>
			<template v-if="currentObj.moduleType == '4'">
				<MeetingMinutes :currentObj="currentObj"></MeetingMinutes>
			</template>
			<template v-if="currentObj.moduleType == '5'">
				<WeeklyOrMonthly :currentObj="currentObj"></WeeklyOrMonthly>
			</template>
			<template v-if="currentObj.moduleType == '6'">
				<AuditOpinion :currentObj="currentObj"></AuditOpinion>
			</template>
			<template v-if="currentObj.moduleType == '7'">
				<SiteExplorationLog :currentObj="currentObj"></SiteExplorationLog>
			</template>
			<template v-if="currentObj.moduleType == '8'">
				<ContactList :currentObj="currentObj"></ContactList>
			</template>
			<template v-if="currentObj.moduleType == '9'">
				<VisasAndClaimsEd :currentObj="currentObj"></VisasAndClaimsEd>
			</template>
			<template v-if="currentObj.moduleType == '10'">
				<CheckSummary :currentObj="currentObj"></CheckSummary>
			</template>
			<template v-if="currentObj.moduleType == '11'">
				<Report :currentObj="currentObj"></Report>
			</template>
			<template v-if="currentObj.moduleType == '12'">
				<AuditPenalty :currentObj="currentObj"></AuditPenalty>
			</template>
			<div slot="footer">
				<el-button class="btn"
						   @click="dialog.show = false">取 消</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import * as ProjectApi from 'api/projectManage/ProjectIndex'
import * as API from 'api/AuditReport/AuditReport'
import * as HomeApi from '@/api/home/homeIndex'
import ColumnFilter from '@/views/Common/ColumnFilter'
import { mapState } from 'vuex'
import { exportExcel } from 'utils/tools'

import AuditPlan from '@/views/AuditReport/components/AuditPlan'
import AuditPenalty from '@/views/AuditReport/components/AuditPenalty'
import AuditLog from '@/views/AuditReport/components/AuditLog'
import AuditSupervision from '@/views/AuditReport/components/AuditSupervision'
import AuditOpinion from '@/views/AuditReport/components/AuditOpinion'
import MeetingMinutes from '@/views/AuditReport/components/MeetingMinutes'
import WeeklyOrMonthly from '@/views/AuditReport/components/WeeklyOrMonthly'
import SiteExplorationLog from '@/views/AuditReport/components/SiteExplorationLog'
import ContactList from '@/views/AuditReport/components/ContactList'
import VisasAndClaimsEd from '@/views/AuditReport/components/VisasAndClaimsEd'
import CheckSummary from '@/views/AuditReport/components/CheckSummary'
import Report from '@/views/AuditReport/components/Report'
export default {
	name: 'AuditReportIndex',
	components: {
		ColumnFilter,
		AuditPlan,
		AuditPenalty,
		AuditLog,
		AuditSupervision,
		MeetingMinutes,
		WeeklyOrMonthly,
		AuditOpinion,
		SiteExplorationLog,
		ContactList,
		VisasAndClaimsEd,
		CheckSummary,
		Report,
	},
	data() {
		return {
			// 搜索条件区域
			searchForm: {
				month: '', //月份
				startYear: '', //选择开始时间
				endYear: '', //选择结束时间
				projectName: '', //工程项目名称
				newProType: '', //项目类型
				start: '', //计划编排类别（0：新建，1：续建，2：发展）
				constructionUnit: '', //建设单位
				constructionType: '', //建设类型
				moduleType: '',
				ids: '', //selectTotalStatistics接口返回的ids参数
			},
			filterTime: '', //筛选时间统计
			filterObj: {}, //筛选对象
			tableObj: {
				data: [], //详细表格数据
				loading: false, //详细表格数据loading
				totalData: [], //合计表格数据
				totalLoading: false, //合计表格数据loading
				projectNum: 0, //当前项目数
			},
			constructionUnitList: [], //建设单位列表
			showFilter: false, //列过滤弹窗显隐
			// 列过滤内容
			filterColumns: [
				{
					title: '',
					checkAll: false,
					columns: [],
				},
			],
			busType: '', //用以区分略过滤模块
			selectRowIndex: 1, // 点击单元格的rowIndex
			selectColumnIndex: 1, // 点击单元格的columnIndex
			filterFiled: '', //点击单元格的field
			dialog: {
				show: false,
				type: '',
				title: '',
			},
			currentObj: '', //列表选中行id
			moduleList: [], //展示的列
		}
	},
	created() {
		// 根据单位类型查询单位
		this.getCompanyList()
		// 获取当前时间(后台)
		this.getContainerParams()
		// 获取自定义列过滤 审计报表合计表
		this.getSelfData('1098009', true)
		// 获取自定义列过滤 审计报表项目表
		this.getSelfData('1098010', true)
		// 获取要展示的列
		this.selectTemplateAuditList()
	},
	methods: {
		/**
		 * @description: 准备工作
		 */

		// 获取当前时间(后台)
		getContainerParams() {
			HomeApi.getContainerParams({}).then((res) => {
				let currentDate = res.data.currentDate
				let endDate = this.$utils.getWhatMonth(currentDate, 0, 'last')
				endDate = this.$utils.toDateString(endDate, 'yyyy-MM-dd')
				let startDate = this.$utils.getWhatMonth(
					currentDate,
					0,
					'first'
				)
				startDate = this.$utils.toDateString(startDate, 'yyyy-MM-dd')
				this.searchForm.month = [startDate, endDate]
				this.searchForm.startYear = startDate
				this.searchForm.endYear = endDate
				// 获取投资管理统计表格数据
				this.selectTotalStatistics(true)
				this.filterTime =
					startDate.substr(0, 7) + ' 至 ' + endDate.substr(0, 7)
			})
		},

		// 获取自定义列过滤数据
		getSelfData(busType, first) {
			let params = { busType }
			let loadingName = busType == '1098009' ? 'totalLoading' : 'loading'
			let refName = busType == '1098009' ? 'topTable' : 'patrolsTable'
			this.tableObj[loadingName] = true
			HomeApi.getSelfData(params)
				.then((res) => {
					if (res.data.length == 0) {
						return
					}
					if (this.$refs[refName]) {
						let tableShowColumn =
							this.$refs[refName].getTableColumn()
						tableShowColumn.collectColumn.forEach((x) => {
							let obj = res.data.find(
								(y) => y.field == x.property
							)
							if (obj) {
								x.visible = obj.isChecked
							}
						})
						this.$refs[refName].refreshColumn()
					}
					this.tableObj[loadingName] = false
					if (!first) {
						this.selectTotalStatistics(true)
					}
				})
				.catch(() => {
					this.tableObj[loadingName] = false
				})
		},

		// 获取统计报表数据
		selectTotalStatistics(first) {
			this.tableObj.totalLoading = true
			API.selectTotalStatistics({
				startYear: this.searchForm.startYear,
				endYear: this.searchForm.endYear,
			})
				.then((res) => {
					this.tableObj.totalData = res.data
					this.tableObj.totalLoading = false
					if (first) {
						if (res.data.length > 0) {
							this.filterObj = this.$utils.clone(
								res.data[1],
								true
							)
							this.searchForm.ids = res.data[1].ids
						}
						// 锁定 瑶海区 合计单元格 并清空 当前操作的filed
						this.selectRowIndex = 1
						this.selectColumnIndex = 1
						this.filterFiled = ''
						// 获取投资管理表格数据
						this.getAuditTableData()
					}
				})
				.catch(() => {
					this.tableObj.totalLoading = false
				})
		},

		// 获取展示的列表
		selectTemplateAuditList() {
			API.selectTemplateAuditList({}).then((res) => {
				this.moduleList = res.data
				this.moduleList.forEach((x, index) => {
					x.type = index
					x.field = x.moduletypeId
				})
				this.moduleList = this.moduleList.filter((x) => x.isView === 1)
			})
		},

		// 获取投资管理表格数据
		getAuditTableData() {
			let params = this.$utils.clone(this.searchForm, true)
			delete params.month
			delete params.startYear
			delete params.endYear
			delete params.moduleType
			this.tableObj.loading = true
			API.selectAuditStatement(params)
				.then((res) => {
					this.tableObj.data = res.data.mapList || []
					this.tableObj.projectNum = res.data.projectIdSum || 0
					this.tableObj.loading = false
				})
				.catch(() => {
					this.tableObj.loading = false
				})
		},

		// 根据单位类型查询单位
		getCompanyList() {
			ProjectApi.selectSysTenantsByType().then((res) => {
				this.$set(this, 'constructionUnitList', res.data.SUBJECT_JSDW)
			})
		},

		/**
		 * @description: 搜索区域操作
		 */

		// 时间change
		monthChange(data) {
			if (!data) {
				this.searchForm.startYear = ''
				this.searchForm.endYear = ''
				this.filterTime = ''
			} else {
				let endDate = this.$utils.getWhatMonth(data[1], 0, 'last')
				endDate = this.$utils.toDateString(endDate, 'yyyy-MM-dd')
				let startDate = this.$utils.getWhatMonth(data[0], 0, 'first')
				startDate = this.$utils.toDateString(startDate, 'yyyy-MM-dd')
				this.searchForm.startYear = startDate
				this.searchForm.endYear = endDate
				this.filterTime = data[0] + ' 至 ' + data[1]
			}
			// 时间变化调用统计接口
			this.selectTotalStatistics(true)
		},

		// 表单搜索
		submitForm() {
			this.getAuditTableData()
		},

		// 重置表单
		resetForm() {
			this.$refs.searchForm.resetFields()
			this.searchForm.projectName = ''
			this.getAuditTableData()
		},

		// 点击列过滤
		doFilter(type, busType) {
			this.$set(this, 'busType', busType)
			this.showFilter = true
			// 区分 table
			let refName = type == 'top' ? 'topTable' : 'patrolsTable'
			// 获取对应 table 的列
			let tableColumn = this.$refs[refName].getTableColumn()
			let collectColumn = this.$utils.clone(
				tableColumn.collectColumn,
				true
			)
			if (type == 'bottom') {
				collectColumn.shift()
				collectColumn.pop()
			} else {
				collectColumn.shift()
				collectColumn.shift()
			}
			this.filterColumns[0].columns = collectColumn

			setTimeout(() => {
				this.$refs.ColumnFilter.dialogObj.visible = true
			}, 200)
		},

		// 确认列过滤
		onFilter(arr) {
			let refName =
				this.busType == '1098009' ? 'topTable' : 'patrolsTable'
			let loadingName =
				this.busType == '1098009' ? 'totalLoading' : 'loading'
			this.tableObj[loadingName] = true
			if (this.$refs[refName]) {
				this.$set(this, 'filterColumns', arr)
				this.getSelfData(this.busType)
				return
			}
			this.tableObj[loadingName] = false
		},

		/**
		 * @description: 表格相关操作
		 */

		// 单元格被点击触发事件
		cellClick({ row, rowIndex, column, columnIndex }) {
			let field = column.field
			if (field == 'name') {
				return
			}
			let obj = this.moduleTypeList.find((x) => x.field == field)
			if (obj) {
				this.searchForm.moduleType = obj.type
			} else {
				this.searchForm.moduleType = ''
			}
			// 保存当前行数据用来渲染中间的提示信息
			this.filterObj = this.$utils.clone(row, true)
			this.filterFiled = this.$utils.clone(field, true)
			// 保存 点击单元的 行下标 和 列下标 用来渲染 active 的样式
			this.selectRowIndex = rowIndex
			this.selectColumnIndex = columnIndex
			// 清空下面搜索表格的搜索条件
			this.searchForm.projectName = ''
			this.searchForm.newProType = ''
			this.searchForm.constructionUnit = ''
			this.searchForm.start = ''
			this.searchForm.constructionType = ''
			// 取出行里的 ids 用作参数
			let ids = this.$utils
				.clone(field, true)
				.replace(/moduleType/, 'ids')
			this.searchForm.ids = row[ids]
			// 根据点击的单元格获取不同的 moduleType 在调取借口
			this.getAuditTableData()
		},

		// 指定单元格赋予样式
		cellStyle({ row, rowIndex, columnIndex }) {
			if (
				rowIndex === this.selectRowIndex &&
				columnIndex === this.selectColumnIndex
			) {
				return 'custom-active-cell'
			}
		},

		// 处理提示语
		customTip() {
			let area = ''
			let total = ''
			let filterFiled = ''
			if (Object.keys(this.filterObj).length > 0) {
				area = this.filterObj.name
				total = this.filterObj.moduleType
				filterFiled = this.filterObj[this.filterFiled]
			}
			let formName = '审计作业表'
			if (![0, 1].includes(this.selectColumnIndex)) {
				let obj = this.moduleTypeList.find(
					(x) => x.field == this.filterFiled
				)
				formName = obj.name || ''
				total = filterFiled
			}
			let msg =
				`统计期内${area}${formName}提交数：${total}个
				<span class="ml15 mr15"> </span>` + `项目数：${this.tableObj.projectNum}个`
			return msg
		},

		// 表格按钮点击事件
		doClick(data, type) {
			if (type == 'enter') {
				if (!this.roleBtns.includes('enter')) {
					return
				}
				let url = this.$outUrl
				let token = this.$getSessionItem('token')
				let tenantId = this.$getSessionItem('tenantId')
				let limitId = this.$getSessionItem('limitId')
				ProjectApi.getAuditWorkPower({
					projectId: data.projectId,
				}).then((res) => {
					if (res.operationCode == 1 && res.msg == 'faild') {
						this.$message.warning(res.data)
						return
					}
					window.open(
						`${url}/DxAuditWork/#/main?projectId=${data.projectId}&token=${token}&tenantId=${tenantId}&limitId=${limitId}&isDataRole=${res.data}`,
						'_blank'
					)
				})
				return
			}

			this.currentObj = data
			this.dialog.title = '查看' + data.moduleTypeName
			this.dialog.show = true
		},

		// 导出excel 审计报表
		exportExcelMethod(type) {
			let params = {
				startYear: this.searchForm.startYear.substring(0, 7), //筛选开始时间
				endYear: this.searchForm.endYear.substring(0, 7), //筛选结束时间
				area: this.filterObj.name,
				list: [],
			}
			//接口返回数据
			params.list =
				type == 'list' ? this.tableObj.data : this.tableObj.totalData

			let baseUrl =
				type == 'list'
					? '/auditDataSummary/exportAuditStatement'
					: '/auditDataSummary/exportTotalStatistic'
			let url = process.env.VUE_APP_BASE_URL + baseUrl
			exportExcel(url, params)
		},

		// 弹窗关闭
		dialogClose() {
			this.dialog.show = false
		},
	},
	computed: {
		...mapState('dict', {
			projectDict: (state) => state.projectDict,
		}),

		...mapState('menu', {
			roleBtns: (state) => state.roleBtns,
		}),

		// 计划编排类别
		typeOptions() {
			let arr = [
				{
					label: '新建项目',
					value: '0',
					id: '100086',
				},
				{
					label: '续建项目',
					value: '1',
					id: '100087',
				},
				{
					label: '开展前期',
					value: '2',
					id: '100088',
				},
			]
			return arr
		},

		// 表单类型
		moduleTypeList() {
			let arr = [
				{
					field: 'moduleType1',
					type: '1',
					name: '审计方案',
				},
				{
					field: 'moduleType2',
					type: '2',
					name: '审计日志',
				},
				{
					field: 'moduleType3',
					type: '3',
					name: '审计监督',
				},
				{
					field: 'moduleType4',
					type: '4',
					name: '会议纪要',
				},
				{
					field: 'moduleType5',
					type: '5',
					name: '周报月报',
				},
				{
					field: 'moduleType6',
					type: '6',
					name: '审计意见单',
				},
				{
					field: 'moduleType7',
					type: '7',
					name: '现场踏勘记录',
				},
				{
					field: 'moduleType8',
					type: '8',
					name: '联系单/变更',
				},
				{
					field: 'moduleType9',
					type: '9',
					name: '签证/索赔',
				},
				{
					field: 'moduleType10',
					type: '10',
					name: '核对纪要',
				},
				{
					field: 'moduleType11',
					type: '11',
					name: '审计报告',
				},
				{
					field: 'moduleType12',
					type: '12',
					name: '审计奖罚单',
				},
			]
			return arr
		},
	},
}
</script>
<style lang='less' scoped>
.AuditReport-layout {
	height: 100%;
	.pdb20 {
		padding-bottom: 20px !important;
	}
	.tips {
		color: #e6a23c;
		font-size: 16px;
	}
	.custom-item {
		display: flex;
		justify-content: flex-end;
	}
	.custom-cell {
		font-size: 16px;
		cursor: pointer !important;
	}
	.custom-cell:hover {
		color: #27a9ff;
	}
	.btn {
		padding: 0 50px !important;
	}
}
</style>
<style lang="less">
.custom-height-audit {
	.el-dialog__body {
		max-height: 700px !important;
	}
}
</style>